import { useEffect, useRef, useState } from "react";

/**
 * Tracks horizontal scroll position and content width of a container element.
 * - `isScrolled`: whether scrollLeft > 0 (for pinned-column shadow effects)
 * - `containerWidth`: the actual content width via ResizeObserver (excludes scrollbar)
 */
export function useScrollShadow() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      setIsScrolled(container.scrollLeft > 0);
    };

    container.addEventListener("scroll", handleScroll, { passive: true });

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        setContainerWidth(entry.contentRect.width);
      }
    });
    observer.observe(container);

    return () => {
      container.removeEventListener("scroll", handleScroll);
      observer.disconnect();
    };
  }, []);

  return { scrollContainerRef, isScrolled, containerWidth };
}
